













import { defineComponent, useContext } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia'

import InPageNavigation from '@/components/feature/PDP/InPageNavigation.vue'
import { useStickyComponent } from '~/composables/ui/useStickyComponent'
import { usePdpStore } from '@/store/pdp'
import { usePDPNavigationObserver } from '~/composables/pdp/usePDPNavigationObserver'

export default defineComponent({
  components: { InPageNavigation },
  setup() {
    const ctx = useContext()
    const isPreviewServer = ctx.$config.cst.isPreview
    const pdpStore = usePdpStore()
    const { showDesktopNavigation } = storeToRefs(pdpStore)
    const { stickyStyle, wrapperRef, isSticky } = useStickyComponent({
      topShift: isPreviewServer ? 145 : 107,
      stickyStart: 960,
    })

    const inPageNavRef = usePDPNavigationObserver(() => {
      if (!isSticky.value) {
        pdpStore.setActiveComponentInNavigation(null)
      }
    })

    return {
      inPageNavRef,
      stickyStyle,
      wrapperRef,
      isSticky,
      showDesktopNavigation,
    }
  },
})
